exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select:invalid,select option[value=\"\"]{color:#999}", ""]);

// exports
